module.exports = __webpack_public_path__ + "static/img/7.2d44b6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/eng/7.png
// module id = bzVV
// module chunks = 0